import getSearchParams from './getSearchParams';

export default (search) => {
  const { token } = getSearchParams(search || window.location.search);
  return token || null;
};
